var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"archives_details"}},[_c('index',[_c('archives-index',{attrs:{"ID":_vm.id,"YearId":_vm.year_id,"CampusId":_vm.campus_id}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }